import WPStagingCommon from '../../wpstg.js';
import {qs} from '../../modules/wpstg-dom-utils.js';
import 'regenerator-runtime/runtime';

let WPStagingBackup;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackup.fetchListing();
  });

  window.addEventListener('backupListingFinished', function() {
    fetch(`${ajaxurl}?action=wpstg--backups--import--file-list&_=${Math.random()}&accessToken=${wpstg.accessToken}&nonce=${wpstg.nonce}&withTemplate=true`)
        .then(WPStagingCommon.handleFetchErrors)
        .then((res) => res.json())
        .then((res) => {
          const $ul = $('.wpstg-backup-list ul');
          $ul.empty();
          $ul.html(res);
        })
        .catch((e) => WPStagingCommon.showAjaxFatalError(e, '', 'Submit an error report.'))
    ;
  });

  window.addEventListener('finishedProcess', function() {
    window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
  });

  window.addEventListener('finishedProcessWithError', function() {
    window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
  });

  WPStagingBackup = {
    performingCancelRequest: false,
    isCancelled: false,
    isFinished: false,
    processInfo: {
      title: null,
      interval: null,
    },
    modal: {
      create: {
        html: null,
        confirmBtnTxt: null,
      },
      process: {
        html: null,
        cancelBtnTxt: null,
        modal: null,
      },
      download: {
        html: null,
      },
      import: {
        html: null,
        btnTxtNext: null,
        btnTxtConfirm: null,
        btnTxtCancel: null,
        searchReplaceForm: null,
        containerIntroduction: null,
        data: {
          file: null, // file path
          fileObject: null, // JS "File" class instance
          search: [],
          replace: [],
          backupMetadata: {},
        },
        baseDirectory: null,
      },
    },
    messages: {
      WARNING: 'warning',
      ERROR: 'error',
      INFO: 'info',
      DEBUG: 'debug',
      CRITICAL: 'critical',
      data: {
        all: [],
        info: [],
        error: [],
        critical: [],
        warning: [],
        debug: [],
      },
      shouldWarn() {
        return WPStagingBackup.messages.data.error.length > 0 ||
        WPStagingBackup.messages.data.critical.length > 0
        ;
      },
      countByType(type = WPStagingBackup.messages.ERROR) {
        return WPStagingBackup.messages.data[type].length;
      },
      addMessage(message) {
        if (Array.isArray(message)) {
          message.forEach((item) => {
            WPStagingBackup.messages.addMessage(item);
          });
          return;
        }
        const type = message.type.toLowerCase() || 'info';
        if (!WPStagingBackup.messages.data[type]) {
          WPStagingBackup.messages.data[type] = [];
        }
        WPStagingBackup.messages.data.all.push(message); // TODO RPoC
        WPStagingBackup.messages.data[type].push(message);
      },
      reset() {
        WPStagingBackup.messages.data = {
          all: [],
          info: [],
          error: [],
          critical: [],
          warning: [],
          debug: [],
        };
      },
    },
    timer: {
      totalSeconds: 0,
      interval: null,
      start() {
        if (null !== WPStagingBackup.timer.interval) {
          return;
        }

        const prettify = (seconds) => {
          console.log(`Process running for ${seconds} seconds`);
          // If potentially anything can exceed 24h execution time than that;
          // const _seconds = parseInt(seconds, 10)
          // const hours = Math.floor(_seconds / 3600)
          // const minutes = Math.floor(_seconds / 60) % 60
          // seconds = _seconds % 60
          //
          // return [hours, minutes, seconds]
          //   .map(v => v < 10 ? '0' + v : v)
          //   .filter((v,i) => v !== '00' || i > 0)
          //   .join(':')
          // ;
          // Are we sure we won't create anything that exceeds 24h execution time? If not then this;
          return `${(new Date(seconds * 1000)).toISOString().substr(11, 8)}`;
        };

        WPStagingBackup.timer.interval = setInterval(() => {
          $('.wpstg--modal--process--elapsed-time').text(prettify(WPStagingBackup.timer.totalSeconds));
          WPStagingBackup.timer.totalSeconds++;
        }, 1000);
      },
      stop() {
        WPStagingBackup.timer.totalSeconds = 0;
        if (WPStagingBackup.timer.interval) {
          clearInterval(WPStagingBackup.timer.interval);
          WPStagingBackup.timer.interval = null;
        }
      },
    },
    status: {
      hasResponse: null,
      reTryAfter: 5000,
    },
    fetchListing(isResetErrors = true) {
      WPStagingCommon.isLoading(true);

      $('#backup-messages').text('');

      if (isResetErrors) {
        WPStagingCommon.resetErrors();
      }

      return fetch(`${ajaxurl}?action=wpstg--backups--listing&_=${Math.random()}&accessToken=${wpstg.accessToken}&nonce=${wpstg.nonce}`)
          .then(WPStagingCommon.handleFetchErrors)
          .then((res) => res.json())
          .then((res) => {
            WPStagingCommon.showAjaxFatalError(res, '', 'Submit an error report.');
            WPStagingCommon.cache.get('#wpstg--tab--backup').html(res);
            WPStagingCommon.isLoading(false);
            window.dispatchEvent(new Event('backupListingFinished'));
            return res;
          })
          .catch((e) => WPStagingCommon.showAjaxFatalError(e, '', 'Submit an error report.'))
      ;
    },
    /**
     * The cancel & cleanup process when we cancel a backup job or when a backup job is stopped due to an error.
     *
     * @param {Object} extraParams Extra parameter to send during cancel process
     * @param {CallableFunction} callback This function is called when a backup cancel/cleanup process response is returned. This callback is always called even if cancel process fails.
     */
    cancel(extraParams = {}, callback = null) {
      WPStagingBackup.timer.stop();
      clearInterval(WPStagingBackup.processInfo.interval);
      WPStagingBackup.isCancelled = true;
      WPStagingBackup.processInfo.interval = null;
      window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
      WPStagingCommon.closeSwalModal();

      WPStagingCommon.getSwalModal(true).fire({
        title: 'Cancelling & Cleaning up',
        text: 'This modal will close automatically when done...',
        icon: 'info',
        showConfirmButton: false,
        showCloseButton: false,
        showLoaderOnConfirm: false,
        showCancelButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        width: 650,
        onRender() {
          WPStagingBackup.sendCancelRequest(
              Object.assign({
                isInit: 'yes',
              }, extraParams),
              callback,
          );
        },
      });
    },
    sendCancelRequest(extraParams, callback) {
      if (WPStagingBackup.performingCancelRequest) {
        return;
      }

      WPStagingBackup.performingCancelRequest = true;

      WPStagingCommon.ajax(
          Object.assign({
            action: 'wpstg--backups--cancel',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            jobIdBeingCancelled: WPStagingCommon.getJobId(),
          }, extraParams),
          function(response) {
            WPStagingBackup.performingCancelRequest = false;
            WPStagingBackup.isCancelled = false;
            WPStagingCommon.showAjaxFatalError(response, '', 'Submit an error report.');

            if (!response.hasOwnProperty('status')) {
              WPStagingCommon.showErrorModal('Cancel process did not finish gracefully. Some temporary files might not have been cleaned up.');
            }

            if (response.status === true) {
              WPStagingCommon.closeSwalModal();
              if (callback !== undefined && callback !== null) {
                callback();
              }
            } else {
              extraParams.isInit = 'no';
              WPStagingBackup.sendCancelRequest(extraParams, callback);
            }
          },
          'json',
          false,
          10, // Don't retry upon failure
          1.25,
          function(xhr, textStatus, errorThrown) {
            WPStagingBackup.performingCancelRequest = false;

            // Todo: Why do we need this?
            WPStagingCommon.continueErrorHandle = false;

            // Resource is busy, wait for request to finish and try again
            if (xhr.status === 423) {
              setTimeout(function() {
                WPStagingBackup.sendCancelRequest(extraParams, callback);
              }, 1000);
              return;
            }
            WPStagingCommon.closeSwalModal();
            WPStagingCommon.showErrorModal('Cancel process did not finish gracefully. Some temporary files might not have been cleaned up.');
            if (callback !== undefined && callback !== null) {
              callback();
            }
          },
      );
    },
    /**
   * If process.execute exists, process.data and process.onResponse is not used
   * process = { data: {}, onResponse: (resp) => {}, onAfterClose: () => {}, execute: () => {}, isShowCancelButton: bool }
   * @param {object} process
   */
    process(process) {
      if (typeof process.execute !== 'function' && (!process.data || !process.onResponse)) {
        WPStagingCommon.closeSwalModal();
        WPStagingCommon.showError('process.data and / or process.onResponse is not set');
        return;
      }

      // TODO move to backend and get the contents as xhr response?
      if (!WPStagingBackup.modal.process.html || !WPStagingBackup.modal.process.cancelBtnTxt) {
        const $modal = $('#wpstg--modal--backup--process');
        const html = $modal.html();
        const btnTxt = $modal.attr('data-cancelButtonText');
        WPStagingBackup.modal.process.html = html || null;
        WPStagingBackup.modal.process.cancelBtnTxt = btnTxt || null;
        $modal.remove();
      }

      $('body')
          .off('click', '.wpstg--modal--process--logs--tail')
          .on('click', '.wpstg--modal--process--logs--tail', function(e) {
            const logBtn = $(this);
            e.preventDefault();
            const container = WPStagingCommon.getSwalContainer();
            const $logs = $(container).find('.wpstg--modal--process--logs');
            $logs.toggle();
            if ($logs.is(':visible')) {
              logBtn.text(wpstg.i18n.hideLogs);
              container.childNodes[0].style.width = '97%';
              container.style['z-index'] = 9999;
            } else {
              logBtn.text(wpstg.i18n.showLogs);
              container.childNodes[0].style.width = '600px';
            }
          })
      ;

      process.isShowCancelButton = false !== process.isShowCancelButton;

      WPStagingBackup.modal.process.modal = WPStagingCommon.getSwalModal(true, {
        content: 'wpstg--process--content',
      }).fire({
        html: WPStagingBackup.modal.process.html,
        cancelButtonText: WPStagingBackup.modal.process.cancelBtnTxt,
        showCancelButton: process.isShowCancelButton,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 600,
        onRender: () => {
          const _btnCancel = WPStagingCommon.getSwalContainer().getElementsByClassName('wpstg--swal2-cancel wpstg--btn--cancel')[0];
          const btnCancel = _btnCancel.cloneNode(true);
          _btnCancel.parentNode.replaceChild(btnCancel, _btnCancel);

          btnCancel.addEventListener('click', function(e) {
            if (confirm('Do you want to cancel the process?')) {
              WPStagingBackup.cancel();
            }
          });

          if (typeof process.execute === 'function') {
            process.execute();
            return;
          }

          if (!process.data || !process.onResponse) {
            WPStagingCommon.closeSwalModal();
            WPStagingCommon.showError('process.data and / or process.onResponse is not set');
            return;
          }

          WPStagingCommon.ajax(process.data, process.onResponse);
        },
        onAfterClose: () => typeof process.onAfterClose === 'function' && process.onAfterClose(),
      });
    },
    processResponse(response) {
      if (response === null) {
        WPStagingCommon.closeSwalModal();
        WPStagingCommon.showError('Invalid Response; null');
        throw new Error(`Invalid Response; ${response}`);
      }

      const $container = $(WPStagingCommon.getSwalContainer());
      const title = () => {
        if ((response.title || response.statusTitle)) {
          $container.find('.wpstg--modal--process--title').text(response.title || response.statusTitle);
        }
      };
      const percentage = () => {
        if (response.percentage) {
          $container.find('.wpstg--modal--process--percent').text(response.percentage);
        }
      };
      const logs = () => {
        if (!response.messages) {
          return;
        }
        const $logsContainer = $container.find('.wpstg--modal--process--logs');
        const stoppingTypes = [
          WPStagingBackup.messages.ERROR,
          WPStagingBackup.messages.CRITICAL,
        ];
        const appendMessage = (message) => {
          if (Array.isArray(message)) {
            for (const item of message) {
              appendMessage(item);
            }
            return;
          }
          const msgClass = `wpstg--modal--process--msg--${message.type.toLowerCase()}`;
          $logsContainer.append(`<p class="${msgClass}">[${message.type}] - [${message.date}] - ${message.message}</p>`);

          if (stoppingTypes.includes(message.type.toLowerCase())) {
            window.dispatchEvent(new CustomEvent('finishedProcessWithError', {
              detail: {
                error: message.message,
              },
            }));
            // Callback approach is used to make sure the logs modal is always shown,
            // after the completion of cancel/cleanup process.
            // Makes sure cancel/cleanup process doesn't close the logs modal.
            // Any other approach would have required a lot of refactoring.
            WPStagingBackup.cancel({}, function() {
              setTimeout(WPStagingBackup.logsModal, 500);
            });
          }
        };
        for (const message of response.messages) {
          if (!message) {
            continue;
          }
          WPStagingBackup.messages.addMessage(message);
          appendMessage(message);
        }

        if ($logsContainer.is(':visible')) {
          $logsContainer.scrollTop($logsContainer[0].scrollHeight);
        }

        if (!WPStagingBackup.messages.shouldWarn()) {
          return;
        }

        const $btnShowLogs = $container.find('.wpstg--modal--process--logs--tail');
        $btnShowLogs.html($btnShowLogs.attr('data-txt-bad'));

        $btnShowLogs
            .find('.wpstg--modal--logs--critical-count')
            .text(WPStagingBackup.messages.countByType(WPStagingBackup.messages.CRITICAL))
        ;

        $btnShowLogs
            .find('.wpstg--modal--logs--error-count')
            .text(WPStagingBackup.messages.countByType(WPStagingBackup.messages.ERROR))
        ;

        $btnShowLogs
            .find('.wpstg--modal--logs--warning-count')
            .text(WPStagingBackup.messages.countByType(WPStagingBackup.messages.WARNING))
        ;
      };

      title();
      percentage();
      logs();

      if (response.jobId) {
        WPStagingCommon.setJobId(response.jobId);
      }

      if (response.status === true && response.job_done === true) {
        WPStagingBackup.timer.stop();
        WPStagingBackup.isCancelled = true;

        window.dispatchEvent(new CustomEvent('finishedProcess', {
          response: response,
        }));
      }
    },
    logsModal() {
      WPStagingCommon.getSwalModal(true, {
        popup: 'wpstg-swal-popup centered-modal',
      }).fire({
        html: `<div class="wpstg--modal--error--logs" style="display:block"></div><div class="wpstg--modal--process--logs" style="display:block"></div>`,
        width: '97%',
        onRender: () => {
          const $container = $(WPStagingCommon.getSwalContainer());
          $container[0].style['z-index'] = 9999;

          const $logsContainer = $container.find('.wpstg--modal--process--logs');
          const $errorContainer = $container.find('.wpstg--modal--error--logs');
          const $translations = $('#wpstg--js--translations');
          const messages = WPStagingBackup.messages;
          const title = $translations.attr('data-modal-logs-title')
              .replace('{critical}', messages.countByType(messages.CRITICAL))
              .replace('{errors}', messages.countByType(messages.ERROR))
              .replace('{warnings}', messages.countByType(messages.WARNING))
        ;

          $errorContainer.before(`<h3>${title}</h3>`);
          const warnings = [
            WPStagingBackup.messages.CRITICAL,
            WPStagingBackup.messages.ERROR,
            WPStagingBackup.messages.WARNING,
          ];

          if (!WPStagingBackup.messages.shouldWarn()) {
            $errorContainer.hide();
          }

          for (const message of messages.data.all) {
            const msgClass = `wpstg--modal--process--msg--${message.type.toLowerCase()}`;

            if (warnings.includes(message.type)) {
              $errorContainer.append(
                  `<p class="${msgClass}">[${message.type}] - [${message.date}] - ${message.message}</p>`,
              );
            }
            $logsContainer.append(
                `<p class="${msgClass}">[${message.type}] - [${message.date}] - ${message.message}</p>`,
            );
          }
        },
        onOpen: (container) => {
          const $logsContainer = $(container).find('.wpstg--modal--process--logs');
          $logsContainer.scrollTop($logsContainer[0].scrollHeight);
        },
      });
    },
    downloadModal({title = null}) {
      if (null === WPStagingBackup.modal.download.html) {
        const $el = $('#wpstg--modal--backup--download');
        WPStagingBackup.modal.download.html = $el.html();
        $el.remove();
      }

      WPStagingCommon.getSwalModal(true).fire({
        'icon': 'success',
        'html': WPStagingBackup.modal.download.html.replace('{title}', title).replace('{btnTxtLog}', 'Show Logs').replace('{text}', 'You can download or restore this backup at any time.'),
        'confirmButtonText': 'Close',
        'showCancelButton': false,
        'showConfirmButton': true,
      });
    },
    statusStop() {
      clearInterval(WPStagingBackup.processInfo.interval);
      WPStagingBackup.processInfo.interval = null;
      window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
    },
    statusStart(process) {
      if (WPStagingBackup.processInfo.interval !== null) {
        return;
      }
      // console.log('Status: Start 2');
      WPStagingBackup.processInfo.interval = setInterval(() => {
        if (true === WPStagingBackup.isCancelled) {
          WPStagingBackup.statusStop();
          return;
        }

        if (WPStagingBackup.status.hasResponse === false) {
          return;
        }

        WPStagingBackup.status.hasResponse = false;
        fetch(`${ajaxurl}?action=wpstg--backups--status&${process}=restore&accessToken=${wpstg.accessToken}&nonce=${wpstg.nonce}`)
            .then((res) => res.json())
            .then((res) => {
              WPStagingBackup.status.hasResponse = true;
              if (typeof res === 'undefined') {
                WPStagingBackup.statusStop();
              }

              if (WPStagingBackup.processInfo.title === res.currentStatusTitle) {
                return;
              }

              WPStagingBackup.processInfo.title = res.currentStatusTitle;
              const $container = $(WPStagingCommon.getSwalContainer());
              $container.find('.wpstg--modal--process--title').text(res.currentStatusTitle);
              $container.find('.wpstg--modal--process--percent').text('0');
            })
            .catch((e) => {
              WPStagingBackup.status.hasResponse = true;
              WPStagingCommon.showAjaxFatalError(e, '', 'Submit an error report.');
            })
        ;
      }, 5000);
    },
  };
}(jQuery));

export default WPStagingBackup;
